<script>
export default {
    name: 'IconMail',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-mail"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M56 15v36H8V15h48zm-6 6L32 34.783 14 21v5.169L32 41l18-14.831V21z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
